import React from "react";
import styled from "styled-components";
import { connect } from "formik";
import { isEmpty, get } from "lodash";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { FormikInputText, FormikInputTypeAhead, FormikInputNumber, DEAL_STATUSES } from "@loanbossinc/component-library";

const StyledGridContainer = styled(Grid)`&&{
    margin-top: 26px
}`;
const StyledFormikInputText = styled(FormikInputText)`&&&&{
    width: 100%
}`;
const StyledHeaderContainer = styled(Grid)`&&{
    margin-top: 23px;
}`;
const StyledHeader = styled.span`&&{
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;

    color: #000000;
}`;
const StyledFormikInputTypeAhead = styled(FormikInputTypeAhead)`
    border-bottom: 1px solid #2196F3;
    width: 100%;
`;
const StyledFormikInputNumber = styled(FormikInputNumber)`&&&&{
    width: 100%
}`;

// there's only 1 lender for quotes
const lenderFieldPath = "details.loanProvider[0].loanCompanyBridge";

const getLenderContacts = values => {
  if (isEmpty(values)) {
    return [];
  }

  const lenderCompanyId = get(values, `${lenderFieldPath}.companyId`);
  if (!lenderCompanyId) {
    return [];
  }
  const lenders = get(values, "ancillary.lenders");
  if (!lenders || lenders.length === 0) {
    return [];
  }
  const ourLender = lenders.filter(x => x.id === lenderCompanyId);
  if (!ourLender) {
    return [];
  }

  return ourLender[0]?.contacts;
};

const getLenderContact = values => {
  if (isEmpty(values) || !values.details) {
    return [];
  }

  const contacts = getLenderContacts(values);
  const lenderCompanyContactId = get(values, `${lenderFieldPath}.companyContactId`);
  if (!contacts || contacts.length === 0 || !lenderCompanyContactId) {
    return null;
  }
  const ourContact = contacts.filter(x => x.id === lenderCompanyContactId);
  if (!ourContact) {
    return null;
  }

  return ourContact[0];
};

const OtherSection = ({ formik, deal }) => {
  const { values } = formik;

  let hasLenderContact;
  if (values.details) {
    hasLenderContact = get(values, `${lenderFieldPath}.companyContactId`);
  }
  let lenderContact = {};
  let emailMailTo = "";
  if (hasLenderContact) {
    lenderContact = getLenderContact(values);
    emailMailTo = lenderContact && lenderContact.email ? `mailto:${lenderContact.email}` : "";
  }

  let loanTypes = values && values.ancillary && values.ancillary.loanTypes ? values.ancillary.loanTypes : [];
  const isAddingSupplemental = deal && deal.dealStatus && deal.dealStatus.id === DEAL_STATUSES.ADDING_SUPPLEMENTAL;
  if (loanTypes && loanTypes.length > 0 && isAddingSupplemental) {
    loanTypes = loanTypes.filter(x => x.id === 6 || x.id === 7);
  }

  return (
    <Grid container>
      <StyledHeaderContainer item xs={12}><StyledHeader>Other</StyledHeader></StyledHeaderContainer>

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputText
          name={"details.other"}
          label={"Other"}
          variant={"filled"}
          multiline
        />
      </StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="loanTypeId"
          name="details.loanTypeId"
          label="Loan Type"
          options={loanTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputNumber
          name={"details.loanTermMonths"}
          label={"Term (months)"}
          variant={"filled"}
        />
      </StyledGridContainer>

    </Grid>
  );
};

export default compose(connect)(OtherSection);
